export const translations = {
  fr: {
    // Navigation
    nav_reserve: "RÉSERVER MAINTENANT",
    nav_contact: "CONTACT",
    
    // Hero Section
    hero_subtitle: "Vivez l'expérience karaoke ultime dans nos boxes privés à Nice.",
    hero_rooms: "7 boxes thématiques",
    hero_booking: "Réservation en ligne",
    hero_cta: "RÉSERVER MAINTENANT",
    hero_discover: "DÉCOUVRIR NOS BOXES",
    
    // Badges
    badge_open: "Ouvert jusqu'à minuit",
    badge_capacity: "De 2 à 12 personnes",
    badge_location: "Nice Centre",
    
    // Rooms Section
    rooms_title: "NOS BOXES",
    rooms_subtitle: "7 boxes privés avec des thématiques uniques pour une expérience inoubliable",
    room_street_view: "Vue rue",
    room_session: "1h/session",
    room_person: "personne",
    room_people: "personnes",
    
    // Room Descriptions
    room_amsterdam_desc: "Vue sur vitrine (on vous voit à l'œuvre 🤩🎤)",
    room_tokyo_desc: "Ambiance authentique",
    room_shanghai_desc: "Intimité et style",
    room_seoul_desc: "Parfait pour petits groupes",
    room_pekin_desc: "Grand box pour groupes",
    room_busan_desc: "Cosy et moderne",
    room_kyoto_desc: "Notre plus grand box",
    
    // Pricing Section
    pricing_title: "TARIFS",
    pricing_subtitle: "Prix par personne, par heure",
    pricing_normal: "HEURES NORMALES",
    pricing_peak: "HEURES PEAK",
    pricing_normal_hours: "Du lundi au vendredi: 16h-19h\nMercredi, samedi, dimanche: 13h-19h",
    pricing_peak_hours: "Tous les jours: 19h-00h",
    pricing_peak_subtitle: "Ambiance nocturne garantie!",
    pricing_opening_hours: "HORAIRES D'OUVERTURE",
    pricing_week_days: "Lun, Mar, Jeu, Ven",
    pricing_weekend: "Mer, Sam, Dim",
    pricing_holidays: "* Pendant les vacances: 13h-00h tous les jours",
    
    // Booking Form
    booking_title: "RESERVATION",
    booking_room: "BOX",
    booking_room_select: "Choisir un box",
    booking_name: "NOM COMPLET",
    booking_phone: "TELEPHONE",
    booking_email: "EMAIL",
    booking_date: "DATE",
    booking_date_select: "Sélectionner une date",
    booking_time: "HEURE DE DEBUT",
    booking_time_select: "Choisir un créneau",
    booking_duration: "DUREE (HEURES)",
    booking_people: "NOMBRE DE PERSONNES",
    booking_requests: "DEMANDES SPECIALES",
    booking_requests_placeholder: "Anniversaire, occasion spéciale...",
    booking_price_title: "PRIX TOTAL",
    booking_hour: "heure",
    booking_hours: "heures",
    booking_submit: "PAYER",
    booking_processing: "TRAITEMENT...",
    booking_modal_title: "RESERVER VOTRE SESSION KARAOKE",
    
    // Contact Section
    contact_title: "CONTACTEZ-NOUS",
    contact_subtitle: "Une question ? Un événement spécial ? Nous sommes là pour vous aider !",
    contact_address: "ADRESSE",
    contact_transport: "TRANSPORT",
    contact_transport_stop: "Arrêt: Alberti / Hôtel Des Postes",
    contact_transport_info: "À 2 minutes à pied • Lignes de tram L1, L2, L3",
    contact_phone: "TELEPHONE",
    contact_phone_form: "Contactez-nous via le formulaire",
    contact_email: "EMAIL",
    contact_email_guarantee: "Réponse sous 24h garantie",
    contact_hours: "HORAIRES",
    contact_hours_week: "Lun-Mar-Jeu-Ven: 16h-00h",
    contact_hours_weekend: "Mer-Sam-Dim: 13h-00h",
    contact_construction: "EN TRAVAUX 🚧",
    contact_construction_text: "Nous préparons actuellement nos superbes boxes ! Ouverture prévue le 2 avril 2026. Réservez dès maintenant pour être parmi les premiers !",
    contact_form_title: "ENVOYEZ-NOUS UN MESSAGE",
    contact_name_placeholder: "Votre nom *",
    contact_email_placeholder: "Votre email *",
    contact_phone_placeholder: "Votre téléphone",
    contact_message_placeholder: "Votre message *",
    contact_send: "ENVOYER LE MESSAGE",
    contact_sending: "ENVOI...",
    
    // Payment Status
    payment_checking: "VERIFICATION DU PAIEMENT...",
    payment_checking_msg: "Veuillez patienter pendant que nous vérifions votre paiement.",
    payment_success: "PAIEMENT REUSSI !",
    payment_success_msg: "Votre réservation a été confirmée. Vous recevrez un email de confirmation avec tous les détails.",
    payment_expired: "SESSION EXPIREE",
    payment_expired_msg: "Votre session de paiement a expiré. Veuillez refaire une réservation.",
    payment_error: "ERREUR DE PAIEMENT",
    payment_error_msg: "Une erreur s'est produite lors de la vérification du paiement.",
    payment_back_home: "RETOUR A L'ACCUEIL",
    payment_new_booking: "NOUVELLE RESERVATION",
    payment_details: "DETAILS DU PAIEMENT",
    payment_amount: "Montant",
    payment_session: "Session",
    
    // Admin
    admin_title: "ADMINISTRATION POP BOX",
    admin_dashboard: "TABLEAU DE BORD ADMIN",
    admin_login: "CONNEXION",
    admin_logout: "DECONNEXION",
    admin_email_placeholder: "Email administrateur",
    admin_password_placeholder: "Mot de passe",
    admin_bookings: "RESERVATIONS RECENTES",
    admin_messages: "MESSAGES DE CONTACT",
    admin_no_bookings: "Aucune réservation pour le moment",
    admin_email_configured: "Email configuré : contact@popboxkaraoke.com",
    admin_email_active: "✓ Actif",
    admin_email_info: "Les messages sont maintenant envoyés directement sur votre email",
    
    // Admin Panel - New Features
    admin_tab_bookings: "Réservations",
    admin_tab_calendar: "Calendrier",
    admin_tab_customers: "Clients",
    admin_tab_manual: "Ajouter",
    admin_tab_block: "Bloquer",
    admin_tab_contacts: "Messages",
    admin_tab_stats: "Statistiques",
    
    // Manual Booking Form
    admin_manual_title: "Créer Réservation Manuelle",
    admin_manual_subtitle: "Ajouter une réservation depuis la boutique",
    admin_manual_box: "Sélectionner Box",
    admin_manual_box_placeholder: "Choisir une box",
    admin_manual_date: "Date de réservation",
    admin_manual_time: "Heure de début",
    admin_manual_time_placeholder: "Sélectionner l'heure",
    admin_manual_duration: "Durée",
    admin_manual_people: "Nombre de personnes",
    admin_manual_price: "Prix Total",
    admin_manual_customer_name: "Nom du client",
    admin_manual_customer_email: "Email du client",
    admin_manual_customer_phone: "Téléphone du client",
    admin_manual_requests: "Demandes spéciales",
    admin_manual_paid_cash: "Payé sur place",
    admin_manual_send_email: "Envoyer email de confirmation",
    admin_manual_create: "Créer la réservation",
    admin_manual_success: "Réservation créée avec succès!",
    admin_manual_error: "Erreur lors de la création",
    
    // Block Slots
    admin_block_title: "Bloquer Créneaux",
    admin_block_subtitle: "Empêcher les réservations en ligne",
    admin_block_form_title: "Nouveau Blocage",
    admin_block_box: "Box à bloquer",
    admin_block_date: "Date",
    admin_block_start: "Heure de début",
    admin_block_end: "Heure de fin",
    admin_block_reason: "Raison du blocage",
    admin_block_reason_placeholder: "Ex: Maintenance, Événement privé...",
    admin_block_create: "Bloquer ce créneau",
    admin_block_list_title: "Créneaux Bloqués",
    admin_block_unblock: "Débloquer",
    admin_block_success: "Créneau bloqué avec succès",
    admin_block_delete_success: "Créneau débloqué",
    admin_block_error: "Erreur lors du blocage",
    admin_block_no_slots: "Aucun créneau bloqué",
    
    // Statistics Dashboard
    admin_stats_title: "Statistiques",
    admin_stats_today: "Aujourd'hui",
    admin_stats_week: "Cette semaine",
    admin_stats_month: "Ce mois",
    admin_stats_bookings: "Réservations",
    admin_stats_revenue: "Revenus",
    admin_stats_customers: "Clients uniques",
    admin_stats_occupancy: "Taux d'occupation",
    admin_stats_alerts: "Alertes Paiement",
    admin_stats_alert_subtitle: "Réservations avec paiement incomplet",
    
    // Search & Filters
    admin_search_placeholder: "Rechercher par nom, email, ID...",
    admin_filter_all: "Tous",
    admin_filter_paid: "Payé",
    admin_filter_partial: "Partiel",
    admin_filter_unpaid: "Impayé",
    admin_filter_box: "Filtrer par box",
    admin_sort_date: "Trier par date",
    admin_sort_amount: "Trier par montant",
    admin_sort_status: "Trier par statut",
    
    // Buttons
    admin_btn_refresh: "Actualiser",
    admin_btn_export: "Export Excel",
    admin_btn_details: "Détails",
    admin_btn_delete: "Supprimer",
    admin_btn_refund: "Rembourser le client",
    admin_btn_mark_treated: "Message traité",
    
    // Internal Notes
    admin_notes_title: "Notes Internes",
    admin_notes_placeholder: "Ajouter une note (ex: Client venu payer sur place)",
    admin_notes_add: "Ajouter Note",
    admin_notes_empty: "Aucune note",
    
    // Refund & Delete
    admin_refund_confirm: "Confirmer le remboursement de",
    admin_refund_success: "Client remboursé avec succès",
    admin_refund_error: "Erreur lors du remboursement",
    admin_delete_confirm: "Êtes-vous sûr de vouloir supprimer cette réservation ?",
    admin_delete_success: "Réservation supprimée",
    admin_delete_error: "Erreur lors de la suppression",
    
    // Toast Messages
    toast_message_sent: "MESSAGE ENVOYE!",
    toast_message_sent_desc: "Nous vous répondrons dans les plus brefs délais.",
    toast_error: "ERREUR",
    toast_message_error: "Impossible d'envoyer le message. Veuillez réessayer.",
    toast_booking_error: "Une erreur s'est produite lors de la réservation",
    toast_invalid_credentials: "Identifiants incorrects"
  },
  
  en: {
    // Navigation
    nav_reserve: "BOOK NOW",
    nav_contact: "CONTACT",
    
    // Hero Section
    hero_subtitle: "Experience the ultimate karaoke in our private boxes in Nice.",
    hero_rooms: "7 themed boxes",
    hero_booking: "Online booking",
    hero_cta: "BOOK NOW",
    hero_discover: "DISCOVER OUR BOXES",
    
    // Badges
    badge_open: "Open until midnight",
    badge_capacity: "2 to 12 people",
    badge_location: "Nice Centre",
    
    // Rooms Section
    rooms_title: "OUR BOXES",
    rooms_subtitle: "7 private boxes with unique themes for an unforgettable experience",
    room_street_view: "Street view",
    room_session: "1h/session",
    room_person: "person",
    room_people: "people",
    
    // Room Descriptions
    room_amsterdam_desc: "Storefront view (you'll be seen in action 🤩🎤)",
    room_tokyo_desc: "Authentic atmosphere",
    room_shanghai_desc: "Intimacy and style",
    room_seoul_desc: "Perfect for small groups",
    room_pekin_desc: "Large box for groups",
    room_busan_desc: "Cozy and modern",
    room_kyoto_desc: "Our largest box",
    
    // Pricing Section
    pricing_title: "PRICING",
    pricing_subtitle: "Price per person, per hour",
    pricing_normal: "NORMAL HOURS",
    pricing_peak: "PEAK HOURS",
    pricing_normal_hours: "Monday to Friday: 4pm-7pm\nWednesday, Saturday, Sunday: 1pm-7pm",
    pricing_peak_hours: "Every day: 7pm-12am",
    pricing_peak_subtitle: "Nighttime atmosphere guaranteed!",
    pricing_opening_hours: "OPENING HOURS",
    pricing_week_days: "Mon, Tue, Thu, Fri",
    pricing_weekend: "Wed, Sat, Sun",
    pricing_holidays: "* During holidays: 1pm-12am every day",
    
    // Booking Form
    booking_title: "BOOKING",
    booking_room: "BOX",
    booking_room_select: "Choose a box",
    booking_name: "FULL NAME",
    booking_phone: "PHONE",
    booking_email: "EMAIL",
    booking_date: "DATE",
    booking_date_select: "Select a date",
    booking_time: "START TIME",
    booking_time_select: "Choose a time slot",
    booking_duration: "DURATION (HOURS)",
    booking_people: "NUMBER OF PEOPLE",
    booking_requests: "SPECIAL REQUESTS",
    booking_requests_placeholder: "Birthday, special occasion...",
    booking_price_title: "TOTAL PRICE",
    booking_hour: "hour",
    booking_hours: "hours",
    booking_submit: "PAY",
    booking_processing: "PROCESSING...",
    booking_modal_title: "BOOK YOUR KARAOKE SESSION",
    
    // Contact Section
    contact_title: "CONTACT US",
    contact_subtitle: "A question? A special event? We're here to help!",
    contact_address: "ADDRESS",
    contact_transport: "TRANSPORT",
    contact_transport_stop: "Stop: Alberti / Hôtel Des Postes",
    contact_transport_info: "2 minutes walk • Tram lines L1, L2, L3",
    contact_phone: "PHONE",
    contact_phone_form: "Contact us via form",
    contact_email: "EMAIL",
    contact_email_guarantee: "24h response guaranteed",
    contact_hours: "HOURS",
    contact_hours_week: "Mon-Tue-Thu-Fri: 4pm-12am",
    contact_hours_weekend: "Wed-Sat-Sun: 1pm-12am",
    contact_construction: "UNDER CONSTRUCTION 🚧",
    contact_construction_text: "We're currently preparing our amazing boxes! Opening scheduled for April 2, 2026. Book now to be among the first!",
    contact_form_title: "SEND US A MESSAGE",
    contact_name_placeholder: "Your name *",
    contact_email_placeholder: "Your email *",
    contact_phone_placeholder: "Your phone",
    contact_message_placeholder: "Your message *",
    contact_send: "SEND MESSAGE",
    contact_sending: "SENDING...",
    
    // Payment Status
    payment_checking: "PAYMENT VERIFICATION...",
    payment_checking_msg: "Please wait while we verify your payment.",
    payment_success: "PAYMENT SUCCESSFUL!",
    payment_success_msg: "Your booking has been confirmed. You will receive an email confirmation with all the details.",
    payment_expired: "SESSION EXPIRED",
    payment_expired_msg: "Your payment session has expired. Please make a new booking.",
    payment_error: "PAYMENT ERROR",
    payment_error_msg: "An error occurred while verifying payment.",
    payment_back_home: "BACK TO HOME",
    payment_new_booking: "NEW BOOKING",
    payment_details: "PAYMENT DETAILS",
    payment_amount: "Amount",
    payment_session: "Session",
    
    // Admin
    admin_title: "POP BOX ADMINISTRATION",
    admin_dashboard: "ADMIN DASHBOARD",
    admin_login: "LOGIN",
    admin_logout: "LOGOUT",
    admin_email_placeholder: "Administrator email",
    admin_password_placeholder: "Password",
    admin_bookings: "RECENT BOOKINGS",
    admin_messages: "CONTACT MESSAGES",
    admin_no_bookings: "No bookings yet",
    admin_email_configured: "Email configured: contact@popboxkaraoke.com",
    admin_email_active: "✓ Active",
    admin_email_info: "Messages are now sent directly to your email",
    
    // Admin Panel - New Features
    admin_tab_bookings: "Bookings",
    admin_tab_calendar: "Calendar",
    admin_tab_customers: "Customers",
    admin_tab_manual: "Add",
    admin_tab_block: "Block",
    admin_tab_contacts: "Messages",
    admin_tab_stats: "Statistics",
    
    // Manual Booking Form
    admin_manual_title: "Create Manual Booking",
    admin_manual_subtitle: "Add a booking from the store",
    admin_manual_box: "Select Box",
    admin_manual_box_placeholder: "Choose a box",
    admin_manual_date: "Booking Date",
    admin_manual_time: "Start Time",
    admin_manual_time_placeholder: "Select time",
    admin_manual_duration: "Duration",
    admin_manual_people: "Number of people",
    admin_manual_price: "Total Price",
    admin_manual_customer_name: "Customer name",
    admin_manual_customer_email: "Customer email",
    admin_manual_customer_phone: "Customer phone",
    admin_manual_requests: "Special requests",
    admin_manual_paid_cash: "Paid on-site",
    admin_manual_send_email: "Send confirmation email",
    admin_manual_create: "Create booking",
    admin_manual_success: "Booking created successfully!",
    admin_manual_error: "Error creating booking",
    
    // Block Slots
    admin_block_title: "Block Time Slots",
    admin_block_subtitle: "Prevent online bookings",
    admin_block_form_title: "New Block",
    admin_block_box: "Box to block",
    admin_block_date: "Date",
    admin_block_start: "Start time",
    admin_block_end: "End time",
    admin_block_reason: "Reason for blocking",
    admin_block_reason_placeholder: "E.g.: Maintenance, Private event...",
    admin_block_create: "Block this slot",
    admin_block_list_title: "Blocked Slots",
    admin_block_unblock: "Unblock",
    admin_block_success: "Slot blocked successfully",
    admin_block_delete_success: "Slot unblocked",
    admin_block_error: "Error blocking slot",
    admin_block_no_slots: "No blocked slots",
    
    // Statistics Dashboard
    admin_stats_title: "Statistics",
    admin_stats_today: "Today",
    admin_stats_week: "This week",
    admin_stats_month: "This month",
    admin_stats_bookings: "Bookings",
    admin_stats_revenue: "Revenue",
    admin_stats_customers: "Unique customers",
    admin_stats_occupancy: "Occupancy rate",
    admin_stats_alerts: "Payment Alerts",
    admin_stats_alert_subtitle: "Bookings with incomplete payment",
    
    // Search & Filters
    admin_search_placeholder: "Search by name, email, ID...",
    admin_filter_all: "All",
    admin_filter_paid: "Paid",
    admin_filter_partial: "Partial",
    admin_filter_unpaid: "Unpaid",
    admin_filter_box: "Filter by box",
    admin_sort_date: "Sort by date",
    admin_sort_amount: "Sort by amount",
    admin_sort_status: "Sort by status",
    
    // Buttons
    admin_btn_refresh: "Refresh",
    admin_btn_export: "Export Excel",
    admin_btn_details: "Details",
    admin_btn_delete: "Delete",
    admin_btn_refund: "Refund Client",
    admin_btn_mark_treated: "Mark as Treated",
    admin_notes_title: "Internal Notes",
    admin_notes_placeholder: "Add note (e.g.: Client paid on-site)",
    admin_notes_add: "Add Note",
    admin_notes_empty: "No notes",
    admin_refund_confirm: "Confirm refund of",
    admin_refund_success: "Client refunded successfully",
    admin_refund_error: "Refund error",
    admin_delete_confirm: "Are you sure you want to delete this booking?",
    admin_delete_success: "Booking deleted",
    admin_delete_error: "Delete error",
    
    // Toast Messages
    toast_message_sent: "MESSAGE SENT!",
    toast_message_sent_desc: "We will respond as soon as possible.",
    toast_error: "ERROR",
    toast_message_error: "Unable to send message. Please try again.",
    toast_booking_error: "An error occurred during booking",
    toast_invalid_credentials: "Invalid credentials"
  },
  
  zh: {
    // Navigation
    nav_reserve: "立即预订",
    nav_contact: "联系我们",
    
    // Hero Section
    hero_subtitle: "在尼斯的私人包房体验终极卡拉OK。",
    hero_rooms: "7个主题包房",
    hero_booking: "在线预订",
    hero_cta: "立即预订",
    hero_discover: "发现我们的包房",
    
    // Badges
    badge_open: "营业至午夜",
    badge_capacity: "2至12人",
    badge_location: "尼斯市中心",
    
    // Rooms Section
    rooms_title: "我们的包房",
    rooms_subtitle: "7个独特主题的私人包房，带来难忘体验",
    room_street_view: "街景",
    room_session: "1小时/场",
    room_person: "人",
    room_people: "人",
    
    // Room Descriptions
    room_amsterdam_desc: "橱窗景观（您会被看到🤩🎤）",
    room_tokyo_desc: "正宗氛围",
    room_shanghai_desc: "私密和风格",
    room_seoul_desc: "适合小团体",
    room_pekin_desc: "团体大包房",
    room_busan_desc: "舒适现代",
    room_kyoto_desc: "我们最大的包房",
    
    // Pricing Section
    pricing_title: "价格",
    pricing_subtitle: "每人每小时价格",
    pricing_normal: "普通时段",
    pricing_peak: "高峰时段",
    pricing_normal_hours: "周一至周五：下午4点-7点\n周三、周六、周日：下午1点-7点",
    pricing_peak_hours: "每天：晚上7点-午夜12点",
    pricing_peak_subtitle: "夜间氛围保证！",
    pricing_opening_hours: "营业时间",
    pricing_week_days: "周一、周二、周四、周五",
    pricing_weekend: "周三、周六、周日",
    pricing_holidays: "* 假期期间：每天下午1点-午夜12点",
    
    // Booking Form
    booking_title: "预订",
    booking_room: "包房",
    booking_room_select: "选择包房",
    booking_name: "全名",
    booking_phone: "电话",
    booking_email: "电子邮件",
    booking_date: "日期",
    booking_date_select: "选择日期",
    booking_time: "开始时间",
    booking_time_select: "选择时间段",
    booking_duration: "时长（小时）",
    booking_people: "人数",
    booking_requests: "特殊要求",
    booking_requests_placeholder: "生日、特殊场合...",
    booking_price_title: "总价",
    booking_hour: "小时",
    booking_hours: "小时",
    booking_submit: "支付",
    booking_processing: "处理中...",
    booking_modal_title: "预订您的卡拉OK场次",
    
    // Contact Section
    contact_title: "联系我们",
    contact_subtitle: "有问题？特殊活动？我们随时为您服务！",
    contact_address: "地址",
    contact_transport: "交通",
    contact_transport_stop: "站点：Alberti / Hôtel Des Postes",
    contact_transport_info: "步行2分钟 • 有轨电车L1、L2、L3线",
    contact_phone: "电话",
    contact_phone_form: "通过表单联系我们",
    contact_email: "电子邮件",
    contact_email_guarantee: "保证24小时内回复",
    contact_hours: "营业时间",
    contact_hours_week: "周一-周二-周四-周五：下午4点-午夜12点",
    contact_hours_weekend: "周三-周六-周日：下午1点-午夜12点",
    contact_construction: "施工中 🚧",
    contact_construction_text: "我们正在准备精彩的包房！即将开业。立即预订成为首批客人！",
    contact_form_title: "给我们留言",
    contact_name_placeholder: "您的姓名 *",
    contact_email_placeholder: "您的电子邮件 *",
    contact_phone_placeholder: "您的电话",
    contact_message_placeholder: "您的留言 *",
    contact_send: "发送留言",
    contact_sending: "发送中...",
    
    // Payment Status
    payment_checking: "支付验证中...",
    payment_checking_msg: "请稍候，我们正在验证您的支付。",
    payment_success: "支付成功！",
    payment_success_msg: "您的预订已确认。您将收到包含所有详细信息的电子邮件确认。",
    payment_expired: "会话已过期",
    payment_expired_msg: "您的支付会话已过期。请重新预订。",
    payment_error: "支付错误",
    payment_error_msg: "验证支付时发生错误。",
    payment_back_home: "返回首页",
    payment_new_booking: "新预订",
    payment_details: "支付详情",
    payment_amount: "金额",
    payment_session: "场次",
    
    // Admin
    admin_title: "POP BOX管理",
    admin_dashboard: "管理仪表板",
    admin_login: "登录",
    admin_logout: "注销",
    admin_email_placeholder: "管理员电子邮件",
    admin_password_placeholder: "密码",
    admin_bookings: "最近预订",
    admin_messages: "联系留言",
    admin_no_bookings: "暂无预订",
    admin_email_configured: "电子邮件已配置：contact@popboxkaraoke.com",
    admin_email_active: "✓ 活跃",
    admin_email_info: "留言现已直接发送到您的电子邮件",
    
    // Admin Panel - New Features
    admin_tab_bookings: "预订",
    admin_tab_calendar: "日历",
    admin_tab_customers: "客户",
    admin_tab_manual: "添加",
    admin_tab_block: "封锁",
    admin_tab_contacts: "留言",
    admin_tab_stats: "统计",
    admin_manual_title: "手动预订",
    admin_manual_subtitle: "从商店添加预订",
    admin_manual_box: "选择包厢",
    admin_manual_date: "预订日期",
    admin_manual_time: "开始时间",
    admin_manual_duration: "时长",
    admin_manual_people: "人数",
    admin_manual_price: "总价",
    admin_manual_customer_name: "客户姓名",
    admin_manual_customer_email: "客户电子邮件",
    admin_manual_customer_phone: "客户电话",
    admin_manual_requests: "特殊要求",
    admin_manual_paid_cash: "现场支付",
    admin_manual_send_email: "发送确认邮件",
    admin_manual_create: "创建预订",
    admin_manual_success: "预订创建成功！",
    admin_block_title: "封锁时段",
    admin_block_subtitle: "阻止在线预订",
    admin_block_box: "要封锁的包厢",
    admin_block_date: "日期",
    admin_block_start: "开始时间",
    admin_block_end: "结束时间",
    admin_block_reason: "封锁原因",
    admin_block_create: "封锁该时段",
    admin_block_list_title: "已封锁时段",
    admin_block_unblock: "解封",
    admin_block_success: "时段封锁成功",
    admin_block_no_slots: "无已封锁时段",
    admin_stats_title: "统计",
    admin_stats_today: "今天",
    admin_stats_week: "本周",
    admin_stats_bookings: "预订",
    admin_stats_revenue: "收入",
    admin_search_placeholder: "按姓名、电子邮件、ID搜索...",
    admin_btn_refresh: "刷新",
    admin_btn_export: "导出Excel",
    admin_btn_delete: "删除",
    admin_btn_refund: "退款客户",
    admin_btn_mark_treated: "标记已处理",
    
    // Toast Messages
    toast_message_sent: "留言已发送！",
    toast_message_sent_desc: "我们会尽快回复。",
    toast_error: "错误",
    toast_message_error: "无法发送留言。请重试。",
    toast_booking_error: "预订时发生错误",
    toast_invalid_credentials: "凭证无效"
  },
  
  it: {
    // Navigation
    nav_reserve: "PRENOTA ORA",
    nav_contact: "CONTATTI",
    
    // Hero Section
    hero_subtitle: "Vivi l'esperienza karaoke definitiva nei nostri box privati a Nizza.",
    hero_rooms: "7 box a tema",
    hero_booking: "Prenotazione online",
    hero_cta: "PRENOTA ORA",
    hero_discover: "SCOPRI I NOSTRI BOX",
    
    // Badges
    badge_open: "Aperto fino a mezzanotte",
    badge_capacity: "Da 2 a 12 persone",
    badge_location: "Centro di Nizza",
    
    // Rooms Section
    rooms_title: "I NOSTRI BOX",
    rooms_subtitle: "7 box privati con temi unici per un'esperienza indimenticabile",
    room_street_view: "Vista strada",
    room_session: "1h/sessione",
    room_person: "persona",
    room_people: "persone",
    
    // Room Descriptions
    room_amsterdam_desc: "Vista vetrina (sarete visti in azione 🤩🎤)",
    room_tokyo_desc: "Atmosfera autentica",
    room_shanghai_desc: "Intimità e stile",
    room_seoul_desc: "Perfetto per piccoli gruppi",
    room_pekin_desc: "Grande box per gruppi",
    room_busan_desc: "Accogliente e moderno",
    room_kyoto_desc: "Il nostro box più grande",
    
    // Pricing Section
    pricing_title: "PREZZI",
    pricing_subtitle: "Prezzo per persona, per ora",
    pricing_normal: "ORARIO NORMALE",
    pricing_peak: "ORARIO DI PUNTA",
    pricing_normal_hours: "Lunedì-Venerdì: 16:00-19:00\nMercoledì, Sabato, Domenica: 13:00-19:00",
    pricing_peak_hours: "Ogni giorno: 19:00-00:00",
    pricing_peak_subtitle: "Atmosfera notturna garantita!",
    pricing_opening_hours: "ORARI DI APERTURA",
    pricing_week_days: "Lun, Mar, Gio, Ven",
    pricing_weekend: "Mer, Sab, Dom",
    pricing_holidays: "* Durante le vacanze: 13:00-00:00 tutti i giorni",
    
    // Booking Form
    booking_title: "PRENOTAZIONE",
    booking_room: "BOX",
    booking_room_select: "Scegli un box",
    booking_name: "NOME COMPLETO",
    booking_phone: "TELEFONO",
    booking_email: "EMAIL",
    booking_date: "DATA",
    booking_date_select: "Seleziona una data",
    booking_time: "ORARIO DI INIZIO",
    booking_time_select: "Scegli un orario",
    booking_duration: "DURATA (ORE)",
    booking_people: "NUMERO DI PERSONE",
    booking_requests: "RICHIESTE SPECIALI",
    booking_requests_placeholder: "Compleanno, occasione speciale...",
    booking_price_title: "PREZZO TOTALE",
    booking_hour: "ora",
    booking_hours: "ore",
    booking_submit: "PAGA",
    booking_processing: "ELABORAZIONE...",
    booking_modal_title: "PRENOTA LA TUA SESSIONE KARAOKE",
    
    // Contact Section
    contact_title: "CONTATTACI",
    contact_subtitle: "Una domanda? Un evento speciale? Siamo qui per aiutarti!",
    contact_address: "INDIRIZZO",
    contact_transport: "TRASPORTI",
    contact_transport_stop: "Fermata: Alberti / Hôtel Des Postes",
    contact_transport_info: "A 2 minuti a piedi • Linee tram L1, L2, L3",
    contact_phone: "TELEFONO",
    contact_phone_form: "Contattaci tramite modulo",
    contact_email: "EMAIL",
    contact_email_guarantee: "Risposta garantita entro 24h",
    contact_hours: "ORARI",
    contact_hours_week: "Lun-Mar-Gio-Ven: 16:00-00:00",
    contact_hours_weekend: "Mer-Sab-Dom: 13:00-00:00",
    contact_construction: "IN COSTRUZIONE 🚧",
    contact_construction_text: "Stiamo attualmente preparando i nostri fantastici box! Apertura molto presto. Prenota ora per essere tra i primi!",
    contact_form_title: "INVIACI UN MESSAGGIO",
    contact_name_placeholder: "Il tuo nome *",
    contact_email_placeholder: "La tua email *",
    contact_phone_placeholder: "Il tuo telefono",
    contact_message_placeholder: "Il tuo messaggio *",
    contact_send: "INVIA MESSAGGIO",
    contact_sending: "INVIO...",
    
    // Payment Status
    payment_checking: "VERIFICA PAGAMENTO...",
    payment_checking_msg: "Attendere prego mentre verifichiamo il pagamento.",
    payment_success: "PAGAMENTO RIUSCITO!",
    payment_success_msg: "La tua prenotazione è stata confermata. Riceverai un'email di conferma con tutti i dettagli.",
    payment_expired: "SESSIONE SCADUTA",
    payment_expired_msg: "La tua sessione di pagamento è scaduta. Si prega di effettuare una nuova prenotazione.",
    payment_error: "ERRORE DI PAGAMENTO",
    payment_error_msg: "Si è verificato un errore durante la verifica del pagamento.",
    payment_back_home: "TORNA ALLA HOME",
    payment_new_booking: "NUOVA PRENOTAZIONE",
    payment_details: "DETTAGLI PAGAMENTO",
    payment_amount: "Importo",
    payment_session: "Sessione",
    
    // Admin
    admin_title: "AMMINISTRAZIONE POP BOX",
    admin_dashboard: "PANNELLO AMMINISTRATIVO",
    admin_login: "ACCEDI",
    admin_logout: "ESCI",
    admin_email_placeholder: "Email amministratore",
    admin_password_placeholder: "Password",
    admin_bookings: "PRENOTAZIONI RECENTI",
    admin_messages: "MESSAGGI DI CONTATTO",
    admin_no_bookings: "Nessuna prenotazione ancora",
    admin_email_configured: "Email configurata: contact@popboxkaraoke.com",
    admin_email_active: "✓ Attivo",
    admin_email_info: "I messaggi vengono ora inviati direttamente alla tua email",
    
    // Admin Panel - New Features
    admin_tab_bookings: "Prenotazioni",
    admin_tab_calendar: "Calendario",
    admin_tab_customers: "Clienti",
    admin_tab_manual: "Aggiungi",
    admin_tab_block: "Blocca",
    admin_tab_contacts: "Messaggi",
    admin_tab_stats: "Statistiche",
    admin_manual_title: "Prenotazione Manuale",
    admin_manual_subtitle: "Aggiungi prenotazione dal negozio",
    admin_manual_box: "Seleziona Box",
    admin_manual_date: "Data prenotazione",
    admin_manual_time: "Ora di inizio",
    admin_manual_duration: "Durata",
    admin_manual_people: "Numero persone",
    admin_manual_price: "Prezzo Totale",
    admin_manual_customer_name: "Nome cliente",
    admin_manual_customer_email: "Email cliente",
    admin_manual_customer_phone: "Telefono cliente",
    admin_manual_requests: "Richieste speciali",
    admin_manual_paid_cash: "Pagato sul posto",
    admin_manual_send_email: "Invia email conferma",
    admin_manual_create: "Crea prenotazione",
    admin_manual_success: "Prenotazione creata!",
    admin_block_title: "Blocca Slot",
    admin_block_subtitle: "Impedisci prenotazioni online",
    admin_block_box: "Box da bloccare",
    admin_block_date: "Data",
    admin_block_start: "Ora inizio",
    admin_block_end: "Ora fine",
    admin_block_reason: "Motivo blocco",
    admin_block_create: "Blocca slot",
    admin_block_list_title: "Slot Bloccati",
    admin_block_unblock: "Sblocca",
    admin_block_success: "Slot bloccato",
    admin_block_no_slots: "Nessuno slot bloccato",
    admin_stats_title: "Statistiche",
    admin_stats_today: "Oggi",
    admin_stats_week: "Questa settimana",
    admin_stats_bookings: "Prenotazioni",
    admin_stats_revenue: "Ricavi",
    admin_search_placeholder: "Cerca per nome, email, ID...",
    admin_btn_refresh: "Aggiorna",
    admin_btn_export: "Esporta Excel",
    admin_btn_delete: "Elimina",
    admin_btn_refund: "Rimborsa Cliente",
    admin_btn_mark_treated: "Segna come Trattato",
    
    // Toast Messages
    toast_message_sent: "MESSAGGIO INVIATO!",
    toast_message_sent_desc: "Risponderemo il prima possibile.",
    toast_error: "ERRORE",
    toast_message_error: "Impossibile inviare il messaggio. Riprova.",
    toast_booking_error: "Si è verificato un errore durante la prenotazione",
    toast_invalid_credentials: "Credenziali non valide"
  },
  
  es: {
    // Navigation
    nav_reserve: "RESERVAR AHORA",
    nav_contact: "CONTACTO",
    
    // Hero Section
    hero_subtitle: "Vive la experiencia karaoke definitiva en nuestros boxes privados en Niza.",
    hero_rooms: "7 boxes temáticos",
    hero_booking: "Reserva online",
    hero_cta: "RESERVAR AHORA",
    hero_discover: "DESCUBRE NUESTROS BOXES",
    
    // Badges
    badge_open: "Abierto hasta medianoche",
    badge_capacity: "De 2 a 12 personas",
    badge_location: "Centro de Niza",
    
    // Rooms Section
    rooms_title: "NUESTROS BOXES",
    rooms_subtitle: "7 boxes privados con temas únicos para una experiencia inolvidable",
    room_street_view: "Vista a la calle",
    room_session: "1h/sesión",
    room_person: "persona",
    room_people: "personas",
    
    // Room Descriptions
    room_amsterdam_desc: "Vista al escaparate (te verán en acción 🤩🎤)",
    room_tokyo_desc: "Ambiente auténtico",
    room_shanghai_desc: "Intimidad y estilo",
    room_seoul_desc: "Perfecto para grupos pequeños",
    room_pekin_desc: "Gran box para grupos",
    room_busan_desc: "Acogedor y moderno",
    room_kyoto_desc: "Nuestro box más grande",
    
    // Pricing Section
    pricing_title: "PRECIOS",
    pricing_subtitle: "Precio por persona, por hora",
    pricing_normal: "HORARIO NORMAL",
    pricing_peak: "HORARIO PUNTA",
    pricing_normal_hours: "Lunes-Viernes: 16:00-19:00\nMiércoles, Sábado, Domingo: 13:00-19:00",
    pricing_peak_hours: "Todos los días: 19:00-00:00",
    pricing_peak_subtitle: "¡Ambiente nocturno garantizado!",
    pricing_opening_hours: "HORARIOS DE APERTURA",
    pricing_week_days: "Lun, Mar, Jue, Vie",
    pricing_weekend: "Mié, Sáb, Dom",
    pricing_holidays: "* Durante vacaciones: 13:00-00:00 todos los días",
    
    // Booking Form
    booking_title: "RESERVA",
    booking_room: "BOX",
    booking_room_select: "Elige un box",
    booking_name: "NOMBRE COMPLETO",
    booking_phone: "TELÉFONO",
    booking_email: "EMAIL",
    booking_date: "FECHA",
    booking_date_select: "Selecciona una fecha",
    booking_time: "HORA DE INICIO",
    booking_time_select: "Elige un horario",
    booking_duration: "DURACIÓN (HORAS)",
    booking_people: "NÚMERO DE PERSONAS",
    booking_requests: "SOLICITUDES ESPECIALES",
    booking_requests_placeholder: "Cumpleaños, ocasión especial...",
    booking_price_title: "PRECIO TOTAL",
    booking_hour: "hora",
    booking_hours: "horas",
    booking_submit: "PAGAR",
    booking_processing: "PROCESANDO...",
    booking_modal_title: "RESERVA TU SESIÓN DE KARAOKE",
    
    // Contact Section
    contact_title: "CONTÁCTANOS",
    contact_subtitle: "¿Una pregunta? ¿Un evento especial? ¡Estamos aquí para ayudarte!",
    contact_address: "DIRECCIÓN",
    contact_transport: "TRANSPORTE",
    contact_transport_stop: "Parada: Alberti / Hôtel Des Postes",
    contact_transport_info: "A 2 minutos a pie • Líneas de tranvía L1, L2, L3",
    contact_phone: "TELÉFONO",
    contact_phone_form: "Contáctanos vía formulario",
    contact_email: "EMAIL",
    contact_email_guarantee: "Respuesta garantizada en 24h",
    contact_hours: "HORARIOS",
    contact_hours_week: "Lun-Mar-Jue-Vie: 16:00-00:00",
    contact_hours_weekend: "Mié-Sáb-Dom: 13:00-00:00",
    contact_construction: "EN CONSTRUCCIÓN 🚧",
    contact_construction_text: "¡Actualmente estamos preparando nuestros increíbles boxes! Apertura muy pronto. ¡Reserva ahora para estar entre los primeros!",
    contact_form_title: "ENVÍANOS UN MENSAJE",
    contact_name_placeholder: "Tu nombre *",
    contact_email_placeholder: "Tu email *",
    contact_phone_placeholder: "Tu teléfono",
    contact_message_placeholder: "Tu mensaje *",
    contact_send: "ENVIAR MENSAJE",
    contact_sending: "ENVIANDO...",
    
    // Payment Status
    payment_checking: "VERIFICACIÓN DE PAGO...",
    payment_checking_msg: "Por favor espera mientras verificamos tu pago.",
    payment_success: "¡PAGO EXITOSO!",
    payment_success_msg: "Tu reserva ha sido confirmada. Recibirás un email de confirmación con todos los detalles.",
    payment_expired: "SESIÓN EXPIRADA",
    payment_expired_msg: "Tu sesión de pago ha expirado. Por favor realiza una nueva reserva.",
    payment_error: "ERROR DE PAGO",
    payment_error_msg: "Ocurrió un error al verificar el pago.",
    payment_back_home: "VOLVER AL INICIO",
    payment_new_booking: "NUEVA RESERVA",
    payment_details: "DETALLES DEL PAGO",
    payment_amount: "Monto",
    payment_session: "Sesión",
    
    // Admin
    admin_title: "ADMINISTRACIÓN POP BOX",
    admin_dashboard: "PANEL DE ADMINISTRACIÓN",
    admin_login: "INICIAR SESIÓN",
    admin_logout: "CERRAR SESIÓN",
    admin_email_placeholder: "Email administrador",
    admin_password_placeholder: "Contraseña",
    admin_bookings: "RESERVAS RECIENTES",
    admin_messages: "MENSAJES DE CONTACTO",
    admin_no_bookings: "Aún no hay reservas",
    admin_email_configured: "Email configurado: contact@popboxkaraoke.com",
    admin_email_active: "✓ Activo",
    admin_email_info: "Los mensajes ahora se envían directamente a tu email",
    
    // Admin Panel - New Features
    admin_tab_bookings: "Reservas",
    admin_tab_calendar: "Calendario",
    admin_tab_customers: "Clientes",
    admin_tab_manual: "Añadir",
    admin_tab_block: "Bloquear",
    admin_tab_contacts: "Mensajes",
    admin_tab_stats: "Estadísticas",
    admin_manual_title: "Reserva Manual",
    admin_manual_subtitle: "Añadir reserva desde la tienda",
    admin_manual_box: "Seleccionar Box",
    admin_manual_date: "Fecha de reserva",
    admin_manual_time: "Hora de inicio",
    admin_manual_duration: "Duración",
    admin_manual_people: "Número de personas",
    admin_manual_price: "Precio Total",
    admin_manual_customer_name: "Nombre del cliente",
    admin_manual_customer_email: "Email del cliente",
    admin_manual_customer_phone: "Teléfono del cliente",
    admin_manual_requests: "Solicitudes especiales",
    admin_manual_paid_cash: "Pagado en el lugar",
    admin_manual_send_email: "Enviar email confirmación",
    admin_manual_create: "Crear reserva",
    admin_manual_success: "¡Reserva creada!",
    admin_block_title: "Bloquear Horarios",
    admin_block_subtitle: "Evitar reservas online",
    admin_block_box: "Box a bloquear",
    admin_block_date: "Fecha",
    admin_block_start: "Hora inicio",
    admin_block_end: "Hora fin",
    admin_block_reason: "Motivo del bloqueo",
    admin_block_create: "Bloquear horario",
    admin_block_list_title: "Horarios Bloqueados",
    admin_block_unblock: "Desbloquear",
    admin_block_success: "Horario bloqueado",
    admin_block_no_slots: "Sin horarios bloqueados",
    admin_stats_title: "Estadísticas",
    admin_stats_today: "Hoy",
    admin_stats_week: "Esta semana",
    admin_stats_bookings: "Reservas",
    admin_stats_revenue: "Ingresos",
    admin_search_placeholder: "Buscar por nombre, email, ID...",
    admin_btn_refresh: "Actualizar",
    admin_btn_export: "Exportar Excel",
    admin_btn_delete: "Eliminar",
    admin_btn_refund: "Reembolsar Cliente",
    admin_btn_mark_treated: "Marcar como Tratado",
    
    // Toast Messages
    toast_message_sent: "¡MENSAJE ENVIADO!",
    toast_message_sent_desc: "Responderemos lo antes posible.",
    toast_error: "ERROR",
    toast_message_error: "No se pudo enviar el mensaje. Por favor intenta de nuevo.",
    toast_booking_error: "Ocurrió un error durante la reserva",
    toast_invalid_credentials: "Credenciales inválidas"
  }
};